import type { AnimationContext } from './types'

const DEFAULT_SIZE = 12

export function setupSparkles(context: AnimationContext): void {
  if (!context.imageContainer || !context.data.sparkles?.length) return

  const setup = () => {
    const img = context.imageContainer?.querySelector('img')
    if (!img || !img.complete) {
      setTimeout(setup, 100)
      return
    }

    requestAnimationFrame(() => {
      for (const sparkle of context.data.sparkles!) {
        const el = document.createElement('div')
        el.className = 'scene-sparkle'
        const size = sparkle.size ?? DEFAULT_SIZE
        el.style.width = `${size}px`
        el.style.height = `${size}px`
        el.style.left = `${sparkle.x}%`
        el.style.top = `${sparkle.y}%`
        if (sparkle.delay) {
          el.style.animationDelay = `${sparkle.delay}s`
        }
        if (sparkle.color) {
          el.style.setProperty('--sparkle-color', sparkle.color)
        }
        context.imageContainer!.appendChild(el)
      }
    })
  }

  requestAnimationFrame(() => setTimeout(setup, 200))
}
